'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
require('prop-types');
var Typography = require('../../../DesignSystem/DataDisplay/Typography/Typography.js');
var classNames = require('classnames');
var withStyles = require('../../../node_modules/@material-ui/core/esm/styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var styles = function styles(theme) {
  var _lineItemImageContain;

  return {
    lineItemImageContainer: (_lineItemImageContain = {
      height: 40,
      width: 40
    }, defineProperty(_lineItemImageContain, theme.breakpoints.up('sm'), {
      width: 60,
      height: 60
    }), defineProperty(_lineItemImageContain, "maxWidth", '100%'), defineProperty(_lineItemImageContain, "position", 'relative'), defineProperty(_lineItemImageContain, "overflow", 'hidden'), defineProperty(_lineItemImageContain, "border", "solid 1px ".concat(theme.palette.secondary.light)), defineProperty(_lineItemImageContain, "borderRadius", 5), _lineItemImageContain),
    imageContainerPDF: {
      width: 60,
      height: 60
    },
    lineItemImage: {
      top: '50%',
      left: '50%',
      position: 'absolute',
      transform: 'translate(-50%, -50%)',
      width: 'auto',
      height: '100%'
    },
    inlineImage: defineProperty({
      "float": 'left',
      minWidth: 50,
      minHeight: 50
    }, theme.breakpoints.up('sm'), {
      minWidth: 70,
      minHeight: 70
    }),
    inlineImagePDF: {
      minWidth: 70,
      minHeight: 70
    },
    tableRow: {
      paddingTop: 8,
      paddingBottom: 8
    },
    inlineText: defineProperty({
      paddingLeft: 58
    }, theme.breakpoints.up('sm'), {
      paddingLeft: 78
    }),
    inlineTextPDF: {
      paddingLeft: 78
    },
    description: {
      whiteSpace: 'pre-line',
      overflowWrap: 'break-word'
    }
  };
};

var LineItemImageAndText = function LineItemImageAndText(_ref) {
  var name = _ref.name,
      description = _ref.description,
      imageUrl = _ref.imageUrl,
      hasLineItemImages = _ref.hasLineItemImages,
      isPDF = _ref.isPDF,
      classes = _ref.classes;
  return React__default["default"].createElement(React.Fragment, null, hasLineItemImages && React__default["default"].createElement("div", {
    className: classNames__default["default"](classes.tableRow, classes.inlineImage, isPDF && classes.inlineImagePDF)
  }, imageUrl && React__default["default"].createElement("div", {
    className: classNames__default["default"](classes.lineItemImageContainer, isPDF && classes.imageContainerPDF)
  }, React__default["default"].createElement("img", {
    src: imageUrl,
    className: classes.lineItemImage
  }))), React__default["default"].createElement("div", {
    className: classNames__default["default"](classes.tableRow, hasLineItemImages && classes.inlineText, isPDF && hasLineItemImages && classes.inlineTextPDF)
  }, React__default["default"].createElement(Typography, {
    variant: "body1",
    align: "left"
  }, name), description && React__default["default"].createElement(Typography, {
    variant: "caption",
    align: "left",
    className: classes.description
  }, description)));
};

LineItemImageAndText.defaultProps = {
  name: '',
  description: '',
  imageUrl: '',
  hasLineItemImage: false
};
var LineItemImageAndText$1 = withStyles(styles)(LineItemImageAndText);

module.exports = LineItemImageAndText$1;
